// @flow
import { _get } from "./methods";

export default {
  listPreviews: (params: any) => _get("/admin/coffee/previews", params)
};
